var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-menu",on:{"click":function($event){return _vm.handleOpenMenus()}}},[_c('img',{attrs:{"src":require("@/assets/images/icones/btn-edite.svg"),"alt":"Download"}}),(_vm.viewMenu)?_c('div',{staticClass:"menu"},[(!_vm.edit)?_c('div',{on:{"click":function($event){return _vm.handleEdite({
          id: _vm.id,
          active: true,
          type: 'edite',
        })}}},[_vm._v(" Editar ")]):_vm._e(),_c('div',{on:{"click":function($event){return _vm.handleDelete(_vm.id)}}},[_vm._v("Remover conta")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }